import React from 'react';
import Detoxification2025 from 'views/Detoxification2025';

const DesktopAppPage = () => {
  return <Detoxification2025 />;
};

export default DesktopAppPage;
